export default function smoothScroll() {
    let isUserClick;
    // Обработчиком клика
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            isUserClick = true;
            smoothScrollToAnchor(this.getAttribute('href'), {
                offsetTop: 24, // Отступ для хедера
                duration: 500 // Длительность анимации 500 мс
            });
        });
    });

    // Обработчик начала скролла
    let scrollTimeout;
    window.addEventListener(
        'scroll',
        () => {
            // Убираем подсветку при начале скролла
            !isUserClick && removeAllAnchorHighlight();

            // Очищаем предыдущий таймаут
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }
        },
        { passive: true }
    );

    // Функция прокрутки
    function smoothScrollToAnchor(selector, options = {}) {
        // Настройки по умолчанию
        const defaultOptions = {
            offsetTop: null, // Дополнительный отступ сверху
            duration: 1000 // Длительность анимации
        };

        // Объединяем переданные опции с настройками по умолчанию
        const settings = { ...defaultOptions, ...options };

        // Находим элемент
        const target = document.querySelector(selector);

        if (!target) {
            console.warn(`Элемент с селектором ${selector} не найден`);
            return;
        }

        // Поиск фиксированного хедера
        const fixedHeader = findFixedHeader();

        // Определяем отступ сверху
        const offsetTop = settings.offsetTop !== null ? (fixedHeader ? fixedHeader.offsetHeight + settings.offsetTop : settings.offsetTop) : 0;

        // Удаляем все активные якорные ссылки
        removeAllAnchorHighlight();

        // Находим активную якорную ссылку
        const activeAnchors = document.querySelectorAll(`a[href="${selector}"]`);

        // Добавляем класс активности
        activeAnchors.forEach(anchor => {
            anchor.classList.add('_active');
        });

        // Вызов smooth скролла
        smoothScroll(target, {
            ...settings,
            offsetTop,
            onComplete: () => {
                // Сбрасываем флаг после завершения анимации
                setTimeout(() => {
                    isUserClick = false;
                }, 50); // Небольшая задержка для надежности
            }
        });
    }

    // Функция удаления подсветки якорной ссылки(для всех якорей)
    function removeAllAnchorHighlight() {
        // Находим все якорные ссылки
        const anchors = document.querySelectorAll(`a[href^="#"]`);
        // Делаем все ссылки на активными
        anchors.forEach(anchor => anchor.classList.remove('_active'));
    }

    // Функция поиска фиксированного хедера
    function findFixedHeader() {
        // Массив селекторов, по которым ищем фиксированный хедер
        const headerSelectors = ['#_nav'];

        // Проверка стилей для определения фиксированности
        for (let selector of headerSelectors) {
            const header = document.querySelector(selector);
            if (header) {
                return header;
            }
        }
        return null;
    }

    // Функция-хелпер прокрутки
    function smoothScroll(target, settings) {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - settings.offsetTop;
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const run = ease(timeElapsed, startPosition, distance, settings.duration);
            window.scrollTo(0, run);
            if (timeElapsed < settings.duration) {
                requestAnimationFrame(animation);
            } else {
                // Вызываем callback после завершения анимации
                if (settings.onComplete) {
                    settings.onComplete();
                }
            }
        }

        // Функция торможения (ease) для более плавной анимации
        function ease(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return (c / 2) * t * t + b;
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
    }
}
